<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Edit Quote</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <router-link to="/admin/quotes" class="btn btn-primary" role="button">
                        back
                    </router-link>
                </div>
            </div>
            <form @submit.prevent="updateQuote" v-if="quote">
                <div class="row justify-content-md-center">
                  <div class="col-12">
                    <div class="row">
                      <div class="col-md-12">
                        <fg-input type="text"
                                  v-model="quote.author"
                                  label="Author"
                                  placeholder="Enter Author"
                                  v-validate="rules.author"
                                  data-vv-name="Author"
                                  cus-name="Author"
                                  :has-errors="errors"
                                  :is-fields="fields">
                        </fg-input>
                      </div>
                      <div class="col-md-12">
                        <fg-input type="text"
                                  v-model="quote.quote"
                                  label="Quote"
                                  placeholder="Enter Quote"
                                  data-vv-name="Quote"
                                  cus-name="Quote"
                                  v-validate="rules.quote"
                                  :has-errors="errors"
                                  :is-fields="fields"
                                  >
                        </fg-input>
                      </div>
                      <div class="col-12" v-if="corps.length">
                        <multiselect
                          v-model="quote.csvCorporationId"
                          placeholder="Select Corporation"
                          :multiple="true"
                          :taggable="true"
                          :options="corps.map(type => type.corporationId)"
                          :custom-label="opt => corps.find(x => x.corporationId == opt).name"
                          required>
                          >
                        </multiselect>
                      </div>
                      <div class="col-3" v-if="status.length">
                        <fg-select
                          v-model="quote.active"
                          label="Status"
                          v-validate="rules.active"
                          data-vv-name="active"
                          cus-name="active"
                          :has-errors="errors"
                          :is-fields="fields"
                          :list="status"
                          selectedKey="id"
                        >
                        </fg-select>
                      </div>
                    </div>
                  </div>
                    <div class="col-6 text-center">
                        <button type="submit" :disabled="errors.any()" class="btn btn-primary btn-fill btn-block">
                            Update Quote
                        </button>
                    </div>
                </div>
                <div class="clearfix"></div>
            </form>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import { imageHelpers } from '../../../../helpers/lambda'
    import moment from 'moment'
    export default {
        name: 'EditQuote',
        created (){
          this.fetchCorporations();
        this.$store.dispatch('GETSELECTEDQUOTE', this.$route.params.id).then(() =>{
            this.quote = this.selectedQuote
            // if (this.quote.csvCorporationId == null && this.quote.csvCorporationId.length == 0)
            if (this.quote.csvCorporationId === null || this.quote.csvCorporationId === undefined) {
              this.quote.csvCorporationId = '0'
            } else {
              this.quote.csvCorporationId = this.quote.csvCorporationId.split(',')
            }
        })
    },
    data () {
        return {
            quote: this.selectedQuote || {},
          rules: {
            bannerMessage: {required : true},
            active: {required: true}
          },
          corps: [],
          message: {
            error: false,
            text: ''
          },
          status: [{name:'Select Status'}, {id:"1", name:'Active'}, {id:"0", name:'Inactive'}],
        }
    },
    methods: {
      fetchCorporations () {
        this.$store.dispatch('FETCH_CORPORATIONS')
          .then((res) => {
            this.corps = res;
            console.log("this.corporations : ", this.corps);
          })
          .catch(err => {
            console.log("API error : ", err);
          }),
          (err) => {
            console.log("err : ", err);
          }
      },
        updateQuote () {
          this.$validator.validateAll().then((result) => {
            if(result){

              let updateQuote = () =>{
                this.$store.dispatch('UPDATE_QUOTE', this.quote)
                  .then((res) => {
                    console.log("UPDATE_EVENT res : ", res);
                    this.showPopup('Success!', 'Quote is successfully updated', 'success', ()=>this.$router.push('/admin/quotes'))

                  })
                  .catch(err => {
                    this.showPopup('Error!', 'some thing happen wrong', 'error')
                    console.log("UPDATE_Quote API error : ", err);
                  })
              };
              updateQuote();
            }
          })
        },
        showPopup(title, msg, popupType, cb){
            this.$swal( title, msg, popupType
            ).then(res => {
                        cb && cb();
                        return res
                    })
        }
    },
    computed: {...mapGetters([
        'quotes', 'selectedQuote']) }
    }
</script>

<style>
    .form-control{
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Quotes/EditQuote.vue